export default {
  "component.globalHeader.search": "站內搜索",
  "component.globalHeader.search.example1": "搜索提示壹",
  "component.globalHeader.search.example2": "搜索提示二",
  "component.globalHeader.search.example3": "搜索提示三",
  "component.globalHeader.help": "使用手冊",
  "component.globalHeader.notification": "通知",
  "component.globalHeader.notification.empty": "妳已查看所有通知",
  "component.globalHeader.message": "消息",
  "component.globalHeader.message.empty": "您已讀完所有消息",
  "component.globalHeader.event": "待辦",
  "component.globalHeader.event.empty": "妳已完成所有待辦",
  "component.noticeIcon.clear": "清空",
  "component.noticeIcon.cleared": "清空了",
  "component.noticeIcon.empty": "暫無資料",
  "component.noticeIcon.view-more": "查看更多",
};
